import classnames from 'classnames';

export function getInlineStylesGeneral(attributes) {

	return {
	/*	...(attributes.aploposition !== undefined && attributes.aploposition !== '') && {position: attributes.aploposition},*/
	// positioning here isn't really correct - just put it in to allow z-index on group which was static
		...(attributes.aplozindex !== undefined && attributes.aplozindex !== 0) && {"position":"relative", zIndex:attributes.aplozindex},
		...(attributes.aplomargintop !== undefined && attributes.aplomargintop !== 0) && {marginTop:attributes.aplomargintop },
		...(attributes.aplomarginbottom !== undefined && attributes.aplomarginbottom !== 0) && {marginBottom:attributes.aplomarginbottom},
		...(attributes.aplomarginleft !== undefined && attributes.aplomarginleft !== 0) && {marginLeft:attributes.aplomarginleft},
		...(attributes.aplomarginright !== undefined && attributes.aplomarginright !== 0) && {marginRight:attributes.aplomarginright},
		/*...(attributes.aplopositiontop !== undefined && attributes.aplopositiontop !== 0) && {top:attributes.aplopositiontop},
		...(attributes.aplopositionbottom !== undefined && attributes.aplopositionbottom !== 0) && {bottom:attributes.aplopositionbottom},
		...(attributes.aplopositionleft !== undefined && attributes.aplopositionleft !== 0) && {left:attributes.aplopositionleft},
		...(attributes.aplopositionright !== undefined && attributes.aplopositionright !== 0) && {right:attributes.aplopositionright},*/
		...(attributes.aploclip !== undefined && attributes.aploclip !== 0) && {"--aplo-clip":attributes.aploclip + "%"},
		...(attributes.overflowhidden !== undefined && attributes.overflowhidden !== false) && {"overflow":"hidden"},
		...(attributes.aploeffectease !== undefined && attributes.aploeffectease !== '') && {"--aplo-teti":attributes.aploeffectease},
		...(attributes.aplohoverease !== undefined && attributes.aplohoverease !== '') && {"--aplo-thti":attributes.aplohoverease},
		...(attributes.aploanimation !== undefined && attributes.aploanimation !== '')  && {"--aplo-anim":attributes.aploanimation},
		

	}
}

export function getInlineVariable(aplofilters) {

	//if (filterHover !== "add") {
		//
		//console.log("got into this function")
		const type = "--aplo-filter-string";

		/* build drop shadow string */
		const shadow = () => {

			if (aplofilters.dsx || aplofilters.dsy) {

				const x = aplofilters.dsx ? aplofilters.dsx + "px ": '0 ';
				const y = aplofilters.dsy ? aplofilters.dsy + "px ": '0 ';
				const b = aplofilters.dsb ? aplofilters.dsb + "px ": '0 ';
				const c = `rgba(var(--aplo-fdsc), ` ;
				const o = aplofilters.dso ? `${aplofilters.dso/100})` : `var(--aplo-fdso))`; 
				return x + y + b + c + o;
			}
			return undefined;

		}

		const filterString = (aplofilters.invert !== undefined ? `invert(${aplofilters.invert}%) ` : '') + 
							(aplofilters.hue !== undefined ? `hue-rotate(${aplofilters.hue}deg) ` : '') + 
							(aplofilters.saturate !== undefined ? `saturate(${aplofilters.saturate}%) ` : '') +
							(aplofilters.sepia !== undefined ? `sepia(${aplofilters.sepia}%) ` : '') + 
							(aplofilters.blur !== undefined ? `blur(${aplofilters.blur}px) ` : '')  +	
							(aplofilters.grayscale !== undefined ? `grayscale(${aplofilters.grayscale}%) ` : '') +
							(aplofilters.brightness !== undefined ? `brightness(${aplofilters.brightness}%) ` : '') +
							(aplofilters.contrast !== undefined ? `contrast(${aplofilters.contrast}%) ` : '') +
							(aplofilters.opacity !== undefined ? `opacity(${aplofilters.opacity}%) ` : '') +							
							(shadow() ? `drop-shadow(${shadow()})` : '');

		return {[type]:filterString}
}

export function getInlineHoverVariable(aplofilters) {

		const type = "--aplo-filter-hover-string";

		/* build drop shadow string */
		const shadow = () => {

			if (aplofilters.dsx || aplofilters.dsy) {

				const x = aplofilters.dsx ? aplofilters.dsx + "px ": '0 ';
				const y = aplofilters.dsy ? aplofilters.dsy + "px ": '0 ';
				const b = aplofilters.dsb ? aplofilters.dsb + "px ": '0 ';
				const c = `rgba(var(--aplo-fdsc), ` ;
				const o = aplofilters.dso ? `${aplofilters.dso/100})` : `var(--aplo-fdso))`; 
				return x + y + b + c + o;
			}
			return undefined;

		}
		const filterString = (aplofilters.invert !== undefined ? `invert(${aplofilters.invert}%) ` : '') + 
							(aplofilters.hue !== undefined ? `hue-rotate(${aplofilters.hue}deg) ` : '') + 
							(aplofilters.saturate !== undefined ? `saturate(${aplofilters.saturate}%) ` : '') +
							(aplofilters.sepia !== undefined ? `sepia(${aplofilters.sepia}%) ` : '') + 
							(aplofilters.blur !== undefined ? `blur(${aplofilters.blur}px) ` : '')  +	
							(aplofilters.grayscale !== undefined ? `grayscale(${aplofilters.grayscale}%) ` : '') +
							(aplofilters.brightness !== undefined ? `brightness(${aplofilters.brightness}%) ` : '') +
							(aplofilters.contrast !== undefined ? `contrast(${aplofilters.contrast}%) ` : '') +
							(aplofilters.opacity !== undefined ? `opacity(${aplofilters.opacity}%) ` : '') +
							(shadow() ? `drop-shadow(${shadow()})` : '');

		/* the square brackets make the value of type the key */
		return {[type]:filterString}

}


/* CHECK FOR PROBLEMS SETTING FILTERS TO 0 */
/********************
 * 
 * Because I am checking for true and 0 of course evaluates as false, could check > 0
 * 
 * 
 * 
 * 
 * 
 */


export function getInlineTransform(aplotransforms) {

	//if (filterHover !== "add") {
		//console.log("got into this function")
		const type = "--aplo-transform-string";
	//	console.log(aplotransforms);
		const transformString = (aplotransforms.rotate ? `rotate(${aplotransforms.rotate}deg) ` : '') + 
							(aplotransforms.scale ? `scale(${(aplotransforms.scale)/100}) ` : '') +
							(aplotransforms.translateY ? `translateY(${aplotransforms.translateY}px) ` : '') +
							(aplotransforms.translateX ? `translateX(${aplotransforms.translateX}px) ` : '');
						

		return {[type]:transformString}
}

export function getInlineHoverTransform(aplotransforms) {

		const type = "--aplo-transform-hover-string";
		const transformString = (aplotransforms.rotate ? `rotate(${aplotransforms.rotate}deg) ` : '') + 
							(aplotransforms.scale ? `scale(${(aplotransforms.scale)/100}) ` : '') +
							(aplotransforms.translateY ? `translateY(${aplotransforms.translateY}px) ` : '') +
							(aplotransforms.translateX ? `translateX(${aplotransforms.translateX}px) ` : '');
		/* the square brackets make the value of type the key */
		return {[type]:transformString}

}

export function getClasses(className,attributes,save=false) {

	// add aploshow class in the editor
	const aploshow = !save ? 'aploshow' : '';

	const {
		aploeffect ,
		aplotexture ,
		aploshadow,
		aplocoveroverlay,
		aplopatterngroup,
		aplomask,
		backdropFilter,
		hasFilters,
		hasHoverFilters,
		galleryswitch,
		hasTransforms,
		hasHoverTransforms,
		haspullstyles,
		aploanimation,

	} = attributes;

	const classes = classnames(className, 
		aploeffect ? `aploanim ${aploeffect} ${aploshow}` : '',
		aplotexture ? `is-style-texture-${aplotexture}` : '',
		aploshadow ? `is-style-aplo-shadow-${aploshadow}` : '',
		aplocoveroverlay ? `is-style-aplo-coveroverlay` : '',
		aplopatterngroup ? `is-style-aplo-pg-${aplopatterngroup}` : '',
		aplomask ? `is-style-aplo-mask-${aplomask}` : '',
		backdropFilter ? 'aplo-bd-f' : '',
		hasFilters > 0 ? 'aplo-has-filters' : '',
		hasHoverFilters > 0 ? 'aplo-has-hover-filters' : '',
		galleryswitch ? 'aplo-gs' : '',
		hasTransforms > 0 ? 'aplo-has-transforms' : '',
		hasHoverTransforms > 0 ? 'aplo-has-hover-transforms' : '',
		haspullstyles > 0 ? 'aplo-has-pull-styles' : '',
		aploanimation ? `has-animation` : '',
	)

	return classes;

}